// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"1646f725","305":"188a027d","799":"8ed33c82"}[chunkId] + ".chunk.js";
};